export default __webpack_public_path__ + "static/media/Incidents-5.f10227dd.png";